// extracted by mini-css-extract-plugin
export default {"bottom":"livestream_faqs__bottom--ojJp","faqs":"livestream_faqs__faqs--jmu+","faq":"livestream_faqs__faq--HTUw"};